import { Card, Icon, TextColor, Typography } from '@repo/ui';
import c from 'classnames';
import React from 'react';

import { getEvaluationIconFromColor } from 'views/Results/Insights/EvaluationGroupsSummary/EvaluationGroupsSummary';
import { useEvaluationGroups } from 'views/Results/Insights/hooks/useEvaluationGroups';
import { CategoryHealthBars } from '../components/CategoryHealthBars';
import { SLIDE_BACKGROUND_COLORS } from '../slideBackgroundColors';

import { AgeGroup, getAgeGroup } from '@repo/utils';
import useCurrentKitAndTinyAccount from 'hooks/useCurrentKitAndTinyAccount';
import styles from './MicrobiomeCategories.module.scss';
import slideStyles from './Slides.module.scss';

export const MicrobiomeCategories: React.FC = () => {
  const { orangeSubMetrics, redSubMetrics, greySubMetrics, greenSubMetrics } =
    useEvaluationGroups();

  const { currentKit, currentTinyAccount } = useCurrentKitAndTinyAccount();
  const isAdult =
    getAgeGroup(currentKit?.age_at_sampling ?? 0) === AgeGroup.ADULT;

  return (
    <div
      className={slideStyles.slideWrapper}
      style={{ backgroundColor: SLIDE_BACKGROUND_COLORS.microbiomeCategories }}
    >
      <div className={styles.contentContainer}>
        <Typography
          variant='heading-m'
          weight='medium'
          color={TextColor.DARKGREEN}
        >
          {isAdult ? 'Your' : `${currentTinyAccount?.first_name}'s`} microbiome
          health
        </Typography>
        <Card variant='wrapper'>
          <div className={styles.cardContent}>
            <div className={styles.item}>
              <div className={c(styles.iconContainer, styles['green'])}>
                <Icon
                  name={getEvaluationIconFromColor('green')}
                  size='s'
                  className={styles['green']}
                />
              </div>
              <Typography variant='heading-m'>
                <Typography variant='heading-m' weight='medium'>
                  {greenSubMetrics.length}
                </Typography>{' '}
                Great results
              </Typography>
            </div>

            <div className={styles.item}>
              <div className={c(styles.iconContainer, styles['grey'])}>
                <Icon
                  name={getEvaluationIconFromColor('grey')}
                  size='s'
                  className={styles['grey']}
                />
              </div>
              <Typography variant='heading-m'>
                <Typography variant='heading-m' weight='medium'>
                  {greySubMetrics.length}
                </Typography>{' '}
                Okay results
              </Typography>
            </div>

            <div className={styles.item}>
              <div className={c(styles.iconContainer, styles['orange'])}>
                <Icon
                  name={getEvaluationIconFromColor('orange')}
                  size='s'
                  className={styles['orange']}
                />
              </div>
              <Typography variant='heading-m'>
                <Typography variant='heading-m' weight='medium'>
                  {orangeSubMetrics.length}
                </Typography>{' '}
                Needs improving
              </Typography>
            </div>

            <div className={styles.item}>
              <div className={c(styles.iconContainer, styles['red'])}>
                <Icon
                  name={getEvaluationIconFromColor('red')}
                  size='s'
                  className={styles['red']}
                />
              </div>
              <Typography variant='heading-m'>
                <Typography variant='heading-m' weight='medium'>
                  {redSubMetrics.length}
                </Typography>{' '}
                Needs support
              </Typography>
            </div>
          </div>
        </Card>
        <Typography variant='heading-m' weight='medium'>
          Categories:
        </Typography>
        <CategoryHealthBars />
      </div>
    </div>
  );
};
